module.exports = __webpack_public_path__ + "img/banner.43580213.jpg";